import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AddOrganizationPageComponent } from "./epicare-public/administration/views/add-organization-page/add-organization-page.component";
import { AdministrationLayoutComponent } from "./epicare-public/administration/views/administration-layout/administration-layout.component";
import { AdministrationPageComponent } from "./epicare-public/administration/views/administration-page/administration-page.component";
import { InvitationPageComponent } from "./epicare-public/administration/views/invitation-page/invitation-page.component";
import { LinkPageComponent } from "./epicare-public/administration/views/link-page/link-page.component";
import { OrganizationPageComponent } from "./epicare-public/administration/views/organization-page/organization-page.component";
import { NotFoundPageComponent } from "./epicare-public/error/views/not-found-page/not-found-page.component";
import { HomePageComponent } from "./epicare-public/home/views/home-page/home-page.component";
import { MetadataPageComponent } from "./epicare-public/home/views/metadata-page/metadata-page.component";
import { SamplesPageComponent } from "./epicare-public/home/views/samples-page/samples-page.component";
import { UploadPageComponent } from "./epicare-public/home/views/upload-page/upload-page.component";
import { LandingPageComponent } from "./epicare-public/landing/views/landing-page/landing-page.component";
import { LoginPageComponent } from "./epicare-public/login/views/login-page/login-page.component";
import { ResetPasswordPageComponent } from "./epicare-public/login/views/reset-password-page/reset-password-page.component";
import { AdministrationGuard } from "./guards/administration.guard";
import { AuthGuard } from "./guards/auth.guard";
import { FunctionalityGuard } from "./guards/functionality.guard";
import { OrganizationDetailsGuard } from "./guards/organization-details.guard";
import { LoginGuard } from "./guards/login.guard";
import { ResetPasswordGuard } from "./guards/reset-password.guard";
import { UserProfileComponent } from "./shared/components/user-profile/user-profile.component";
import { Functionality } from "./shared/constants/functionality.constants";

const routes: Routes = [
  {
    path: "",
    redirectTo: "landing",
    pathMatch: "full",
  },
  {
    path: "landing",
    component: LandingPageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "login",
    component: LoginPageComponent,
    canActivate: [LoginGuard],
  },
  {
    path: "reset-password",
    component: ResetPasswordPageComponent,
    canActivate: [ResetPasswordGuard],
  },
  {
    path: "administration",
    component: AdministrationLayoutComponent,
    canActivate: [AuthGuard, AdministrationGuard],
    children: [
      {
        path: "",
        component: AdministrationPageComponent,
      },
      {
        path: "add-organization",
        component: AddOrganizationPageComponent,
        canActivate: [FunctionalityGuard],
        data: { functionality: Functionality.CREATE_ORGANIZATION },
      },
      {
        path: "organization/:id",
        component: OrganizationPageComponent,
        canActivate: [OrganizationDetailsGuard],
      },
    ],
  },
  {
    path: "invitation",
    component: InvitationPageComponent,
  },
  {
    path: "link",
    component: LinkPageComponent,
  },
  {
    path: "home",
    component: HomePageComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "upload",
        component: UploadPageComponent,
        canActivate: [FunctionalityGuard],
        data: { functionality: Functionality.IMPORT_DATA },
      },
      { path: "samples", component: SamplesPageComponent },
      { path: "metadata/:id", component: MetadataPageComponent },
      { path: "", redirectTo: "upload", pathMatch: "full" },
    ],
  },
  {
    path: "profile",
    component: UserProfileComponent,
    canActivate: [AuthGuard],
  },
  {
    // Always have to be the last in the list
    path: "**",
    component: NotFoundPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
